import { Link } from 'react-router-dom';
import './App.css';

const Home = () => {
    const links = [
        {
          url: "https://prince5.netlify.app/",
          imgSrc: "1.jpeg",
          text: "Portfolio 1",
        },
        {
          url: "https://princemaurya20.netlify.app",
          imgSrc: "11.png",
          text: "Portfolio 2",
        },
        {
          url: "https://prince2.netlify.app",
          imgSrc: "12.jpeg",
          text: "Portfolio 3",
        },
        {
          url: "https://agro-shields.vercel.app/",
          imgSrc: "farmer.png",
          text: "Agro Shield - IoT based crop recommendation system",
        },
        {
          url: "https://mini-meet-prince.vercel.app/",
          imgSrc: "meet.jpg",
          text: "Mini Meet - Video Conferencing App",
        },
        {
          url: "https://meditrack-mindsprint.vercel.app/",
          imgSrc: "medicine.jpg",
          text: "MediTrack - Medicine Reminder App",
        },
        {
          url: "https://team-duo-dare-r2.vercel.app/",
          imgSrc: "mentor.jpg",
          text: "Education Tech - Mentor-Mentee Platform",
        },
        {
          url: "https://team-duo-dare.vercel.app/",
          imgSrc: "space.jpg",
          text: "Space Explorer",
        },
        {
          url: "https://zennit-ui-hackathon.vercel.app/",
          imgSrc: "hackathon1.jpg",
          text: "Zennit UI - Hackathon Project",
        },
        {
          url: "https://genai-artwork-f.vercel.app/",
          imgSrc: "gen.jpg",
          text: "GenAI Artwork",
        },
        {
          url: "https://contact-app-ip-5.vercel.app/",
          imgSrc: "contact.jpg",
          text: "Contact App",
        },
        {
          url: "https://inventory10.netlify.app/",
          imgSrc: "2.png",
          text: "Inventory Management",
        },
        {
          url: "https://examinationportal.netlify.app/",
          imgSrc: "3.png",
          text: "Online Examination Portal",
        },
        {
          url: "https://voting10.netlify.app",
          imgSrc: "4.jpeg",
          text: "Centrailzed Voting System",
        },
        {
          url: "https://vbot.netlify.app",
          imgSrc: "5.jpeg",
          text: "Virtual Bot",
        },
        {
          url: "https://rest2.netlify.app",
          imgSrc: "6.jpeg",
          text: "Online Restaurant Page",
        },
        {
          url: "https://hotel99.netlify.app",
          imgSrc: "7.jpg",
          text: "Online Hotel Management",
        },
        {
          url: "https://chat66.netlify.app",
          imgSrc: "8.jpeg",
          text: "Web - based Chat Application",
        },
        {
          url: "https://modelanswer.netlify.app",
          imgSrc: "9.png",
          text: "Educational - Model answer, msbte",
        },
        {
          url: "https://princeqr.netlify.app",
          imgSrc: "10.jpeg",
          text: "QR Code Generator",
        },
        {
          url: "https://table-tops.netlify.app",
          imgSrc: "6.jpeg",
          text: "Restaurant - Table-tops",
        },
        {
          url: "https://lastminuteproject.netlify.app",
          imgSrc: "last.jpeg",
          text: "Last Minute Project",
        },
        {
          url: "https://expense4.netlify.app",
          imgSrc: "exp.jpeg",
          text: "Expense Tracker",
        },
        {
          url: "https://termwork.netlify.app",
          imgSrc: "term.jpeg",
          text: "Term Work Tracker",
        },
      ];
    return(
        <>
        <div id="dynamicLinks">
          <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Web-2.0 Projects</p>
            {links.map((link, index) => (
              <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                <div className="main-child">
                  <div className="img-view">
                    <img src={link.imgSrc} alt={link.text} />
                  </div>
                  <div className="text">
                    <p>{link.text}</p>
                  </div>
                </div>
              </a>
            ))}
        </div>
        </>
    )
};

export default Home;